import { all } from 'redux-saga/effects'

import listSaga from './list/saga'

export function* tariffsSaga() {
  yield all([listSaga()])
}
